export default __webpack_public_path__ + "static/media/search.7b1accb2.svg";